var exports = {
  "Nr": "ThemeDiscoveryCard.module__card___V1piOW",
  "Bm": "ThemeDiscoveryCard.module__cardActive___V1piOW",
  "NK": "ThemeDiscoveryCard.module__paletteHeader___V1piOW",
  "nf": "ThemeDiscoveryCard.module__swatch___V1piOW",
  "Qs": "ThemeDiscoveryCard.module__content___V1piOW",
  "$": "ThemeDiscoveryCard.module__titleRow___V1piOW",
  "UU": "ThemeDiscoveryCard.module__name___V1piOW",
  "AZ": "ThemeDiscoveryCard.module__categoryBadge___V1piOW",
  "cy": "ThemeDiscoveryCard.module__author___V1piOW",
  "h_": "ThemeDiscoveryCard.module__description___V1piOW",
  "qr": "ThemeDiscoveryCard.module__footer___V1piOW",
  "ew": "ThemeDiscoveryCard.module__statsRow___V1piOW",
  "Zm": "ThemeDiscoveryCard.module__applyBtn___V1piOW",
  "Jk": "ThemeDiscoveryCard.module__activeBtn___V1piOW",
};

module.exports = exports;
